// helpers/ownerEngineerValidation.js
// Valida si los documentos de propietario y electricista son iguales

export function isOwnerEngineerSame(docProp, docEng) {
  return docProp && docEng && docProp === docEng;
}

export const OWNER_ENGINEER_WARNING_MSG =
  'Los datos del propietario no pueden coincidir con los del ingeniero/electricista responsable de la obra. Si el ingeniero/electricista también es propietario del inmueble, deberá adjuntar el documento que lo acredite en el espacio correspondiente. De lo contrario, no será posible continuar con el registro.';
